import React from 'react';
import classNames from 'classnames';
import { Reactions } from '../../../ui';
import { isDefined } from '../../../ts-utils';
import { HAS_REACTION, REACTION_MENU, REACTION_MENU_DATA, REACTION_PENDING, } from '../../data-hooks';
import { defaultReactionsInMenu, resolveMainReactionName } from '../../default-reactions';
import { ReactionIcon } from '../../reaction-icon/reaction-icon';
import { getReactionKeyByName } from '../../utils/get-reaction-key';
import { getReactionCode, getReactionName } from '../../utils/reaction-converters';
import { getValidReactions } from '../../utils/get-valid-reactions';
import styles from './emotions-button.module.scss';
import noop from 'lodash/noop';
import cssVars from '../../styles/css-vars.module.scss';
export const EmotionsButton = ({ className, config, isPending, isMobile, t, isDisabled, onClick, reactions, }) => {
    const validReactions = getValidReactions(reactions, config);
    const activeReaction = validReactions.find((r) => r.hasReacted)?.reactionCode;
    const mainReactionName = resolveMainReactionName(config.mainEmotion);
    const isMainReaction = (reactionName) => reactionName === mainReactionName;
    const popoverReactions = [
        ...(config.emotions ? config.emotions : defaultReactionsInMenu),
    ].filter(isDefined);
    const renderReactionIcon = (reactionName) => {
        const reactionCode = getReactionCode(reactionName, mainReactionName);
        return (React.createElement(ReactionIcon, { className: styles.reactionIcon, dataHook: reactionCode, reactionName: reactionName }));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Reactions, { "data-hook": REACTION_MENU, className: classNames(styles.root, isDisabled && styles.isDisabled, isMobile && styles.isMobile, !!activeReaction && styles.hasActiveReaction, mainReactionName === 'heart' && styles.isHeartIcon, (mainReactionName === 'thumbsup'
                ? activeReaction === ':like:'
                : activeReaction === ':thumbs_up:') && styles.isThumbsUpIcon, mainReactionName === 'thumbsup' && styles.isThumbsUpIconMain, cssVars.reactionsContainer, className), 
            /* WUT reads `mobile` from TPAComponentsContext; the local Reactions takes it as a prop
               and uses it to omit the sub-trigger button, as ReactionButton.js does. */
            mobile: isMobile, defaultReaction: mainReactionName, popoverTriggerAriaLabel: `${t('reaction-button.aria-label')} ${activeReaction
                ? t('reaction-button.aria-label-has-reaction', {
                    reaction: t(getReactionKeyByName(getReactionName(activeReaction, mainReactionName))),
                })
                : ''}`, onReactionSelect: isDisabled
                ? noop
                : (reactionName) => {
                    if (reactionName) {
                        // select
                        onClick?.(getReactionCode(reactionName, mainReactionName));
                    }
                    else if (activeReaction) {
                        // deselect
                        onClick?.(activeReaction);
                    }
                    else {
                        // skip as there was nothing selected and nothing deselected.
                    }
                }, additionalReactions: popoverReactions, reactionLabel: (reactionName) => isMainReaction(reactionName) ? t('reaction.like') : t(getReactionKeyByName(reactionName)), reactionIcon: renderReactionIcon, selectedId: activeReaction ? getReactionName(activeReaction, mainReactionName) : undefined }),
        React.createElement("span", { "data-hook": `${REACTION_MENU_DATA} ${activeReaction ? HAS_REACTION : ''} ${isPending ? REACTION_PENDING : ''}`, "aria-hidden": "true" })));
};
//# sourceMappingURL=emotions-button.js.map